import { render, staticRenderFns } from "./LeaderboardGuildTable.vue?vue&type=template&id=0b13905b&scoped=true&"
import script from "./LeaderboardGuildTable.vue?vue&type=script&lang=js&"
export * from "./LeaderboardGuildTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13905b",
  null
  
)

export default component.exports